import { z } from 'zod';

import {
  BackgroundColor,
  FlexAlignment,
  ImageLoadingMethod,
  ImageOverlayStyle,
} from '../models';
import { BasePType } from './base';
import { Image } from './image';

export const VideoModal = BasePType.extend({
  type: z.enum(['videoModal']),
  bgColor: z.nullable(BackgroundColor),
  description: z.string().nullable(),
  flexAlignment: z.nullable(FlexAlignment),
  loading: z.nullable(ImageLoadingMethod),
  overlayText: z.string().nullable(),
  alignment: z.string().nullable(),
  imageLoading: z.string().nullable(),
  imageStyle: z.nullable(ImageOverlayStyle),
  title: z.string().nullable(),
  videoOverlay: z.array(Image),
  videoUrl: z.string(),
});

export type VideoModal = z.infer<typeof VideoModal>;
